import toast from "react-hot-toast";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";

// Toaster functions
export const notifySuccess = (msg) => toast.success(msg);

export const notifyError = (msg) => toast.error(msg);

export const notifyInfo = (msg) =>
  toast(msg, {
    style: {
      background: "#ffffb3",
    },
    icon: "⚠️",
  });

// Email formatting function
export const getFormattedEmail = (email) => {
  const [name, domain] = email.split("@");
  let formattedEmail = "";
  for (let i = 0; i < name.length; i++) {
    if (i < 3) {
      formattedEmail += name[i];
    } else {
      formattedEmail += "*";
    }
  }
  return `${formattedEmail}@${domain}`;
};

// Auth token functions
export const saveAuthToken = (token) => {
  localStorage.setItem("access_token_PA_Admin", token);
};

export const deleteAuthToken = () => {
  notifyError("Session expired, please login again.");
  localStorage.removeItem("access_token_PA_Admin");
};

export const speakText = async (text, onStart = () => {}, onEnd = () => {}) => {
  const speechKey = process.env.REACT_APP_AZURE_SPEECH_KEY;
  const speechRegion = process.env.REACT_APP_AZURE_SPEECH_REGION;

  if (!speechKey || !speechRegion) {
    throw new Error("Azure Speech key or region is not configured.");
  }

  const speechConfig = sdk.SpeechConfig.fromSubscription(
    speechKey,
    speechRegion
  );
  speechConfig.speechSynthesisVoiceName = "en-US-JennyNeural";

  const audioConfig = sdk.AudioConfig.fromDefaultSpeakerOutput();
  const synthesizer = new sdk.SpeechSynthesizer(speechConfig, audioConfig);

  return new Promise((resolve, reject) => {
    onStart();

    // Optional: handle completed synthesis
    synthesizer.synthesisCompleted = () => {
      onEnd();
      synthesizer.close();
      resolve();
    };

    synthesizer.synthesisCanceled = (s, e) => {
      onEnd();
      synthesizer.close();
      console.error("Synthesis canceled:", e);
      reject(e);
    };

    synthesizer.speakTextAsync(
      text,
      () => {}, // No need to handle result here
      (err) => {
        onEnd();
        synthesizer.close();
        console.error("Speech synthesis error:", err);
        reject(err);
      }
    );
  });
};

export const getDateFormatted = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });
};

export const formatNumber = (num) => {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "m";
  }
  if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  return num.toString();
};

// For percentage calculation in number format
export const calculatePercentage = (value, total) => {
  const v = Number(value);
  const t = Number(total);

  if (!isFinite(v) || !isFinite(t) || t === 0) {
    return 0; // Safe fallback
  }

  return Number(((v / t) * 100).toFixed(2));
};



export const getLangCode = (language) => {
  if (!language) return "";
  if (language.toLowerCase() === "english") return "en";
  if (language.toLowerCase() === "dutch") return "nl";
  if (language.toLowerCase() === "flemish") return "nl-BE";
  if (language.toLowerCase() === "french") return "fr";
  return language.slice(0, 2).toLowerCase(); // fallback
};

